import LockIcon from '@mui/icons-material/Lock';
import { Button, CardContent, CardHeader, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { ControlledTextInput } from '../../../../components/basics/ControlledTextInput';
import { useAuthContext } from '../../../../context/AuthContextProvider';
import { CustomCard } from '../../../../themes/theme/GlobalStyledComponents';
import { EditPasswordModal } from './EditPasswordModal';

export const TabProfile = () => {
  const { user } = useAuthContext();

  const [showEditPasswordModal, setShowEditPasswordModal] = useState<boolean>(false);

  const { control, reset } = useForm();

  useEffect(() => {
    reset({
      email: user?.email,
      first_name: user?.nome
    });
  }, [user]);

  return (
    <>
      <CustomCard sx={{ mt: 4 }}>
        <CardContent>
          <CardHeader title="Dados Pessoais" subheader="Utilize os campos abaixo para modificar seus dados pessoais e de contato." />
          <Grid container spacing={4} sx={{ px: 2 }}>
            <Grid item xs={12} md={6}>
              <ControlledTextInput label="E-mail" control={control} name="email" type="text" variant="standard" />
            </Grid>
            <Grid item xs={12} md={6}>
              <ControlledTextInput label="Nome" control={control} name="first_name" type="text" variant="standard" />
            </Grid>
          </Grid>
        </CardContent>
      </CustomCard>
      <CustomCard sx={{ mt: 2 }}>
        <CardContent>
          <CardHeader title="Segurança" subheader="Utilize os campos abaixo para modificar informações de segurança do seu perfil." />
          <Grid container spacing={4} sx={{ px: 2 }}>
            <Grid item xs={12} md={12}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<LockIcon />}
                onClick={() => setShowEditPasswordModal(true)}
                disabled={!user}
              >
                Editar Senha
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </CustomCard>
      {showEditPasswordModal && <EditPasswordModal showModal={showEditPasswordModal} hideModal={() => setShowEditPasswordModal(false)} />}
    </>
  );
};
